import { render, staticRenderFns } from "./MobiCashRefund.vue?vue&type=template&id=20f31020"
import script from "./MobiCashRefund.vue?vue&type=script&lang=js"
export * from "./MobiCashRefund.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports